import {ColumnKey} from "../constants/display-columns";

export class CaruzEnrollment {
    Fname: string
    Pname: string
    number: number
    sex: string
    SectionName: string
    RollName: string
    score: string
    chip: string
    location: string
    time: string
    key: string
    club?: string

    constructor(jsonObject: any) {
        this.Fname = jsonObject.Fname
        this.Pname = jsonObject.Pname
        this.number = jsonObject.number
        this.sex = jsonObject.sex
        this.SectionName = jsonObject.SectionName
        this.RollName = jsonObject.RollName
        this.score = jsonObject.score
        this.chip = jsonObject.chip
        this.location = jsonObject.location
        this.time = jsonObject.time
        this.key = jsonObject.toolkitRecordId
        this.club = jsonObject.club
    }

    static instantiateFromArr(jsonObjects: any[]) {
        return jsonObjects.map(jsonObject => new CaruzEnrollment(jsonObject))
    }

    fullName() {
        if(this.Pname == null) {
            return null
        }
        return this.Pname + ' ' + this.Fname
    }

    getValueForColumnKey(columnKey: ColumnKey): string | number | null | undefined {
        switch (columnKey) {
            case ColumnKey.Chip:
                return this.chip
            case ColumnKey.Score:
                return this.score
            case ColumnKey.Club:
                return this.club
            case ColumnKey.Location:
                return this.location
            case ColumnKey.Name:
                return this.fullName()
            case ColumnKey.Number:
                return this.number
            case ColumnKey.RollName:
                return this.RollName
            case ColumnKey.SectionName:
                return this.SectionName
            case ColumnKey.Sex:
                return this.sex
            case ColumnKey.Time:
                return this.time
            default:
                throw new Error(`Unknown column key: ${columnKey}`)
        }
    }
}